import store from '@/store'

let guard = () => new Promise((resolve, reject) => {
  return (store.getters['auth/isAdmin'] === true) ? resolve() : reject({
    name: 'dashboard'
  })
})

export default {
  name: 'admin',
  run: guard
}